import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Semester } from '../../_models/academic/learning-path/semester.interface';
import * as moment from 'moment';
import { Paper } from '../../_models/academic/learning-path/paper.interface';
import { Electronic } from '../../_models/academic/learning-path/electronic.interface';

@Injectable({
  providedIn: 'root'
})
export class SemesterLMSService {
  private data: Semester;

  constructor() {
    this.data = {
      id: 1,
      name: '2018-2019 Semester One',
      startDate: moment('20/09/2018', 'DD/MM/YYYY'),
      endDate: moment('31/12/2018', 'DD/MM/YYYY')
    };
  }

  public ChangeNotefier = new EventEmitter();

  setSemester(item: Semester) {
    this.data = { ...item };
    this.ChangeNotefier.emit(this.data);
  }

  getAYear() :Semester{
    return {
      id:1,
      name:"2018-2019",
      startDate:moment("20/09/2018" , "DD/MM/YYYY"),
      endDate:moment("29/5/2019" , "DD/MM/YYYY"),

    } 
  }


  getSemester() {
    return this.data;
  }

  getSemesterWeeks(sectionSubjectId: number, WeeklyService: PaperWeeklyService | ElectronicWeeklyService): Semester[] {
    let list: Semester[] = [];

    let nweek = this.data.endDate.diff(this.data.startDate, 'weeks');
    let nday = this.data.endDate.diff(this.data.startDate, 'days');
    let c = nweek * 7;

    if (c == nday) {
    } else {
      nweek = nweek + 1;
    }

    let startdate = moment(this.data.startDate);
    let enddate = moment(this.data.startDate).isoWeekday(6);
    //  console.log(enddate.format("DD MMM YYYY"))
    for (let i = 0; i < nweek; i++) {
      const sdate = moment(startdate).isoWeekday(0);
      const edate = moment(enddate).isoWeekday(6);

      //console.log("start :"+startdate.format("DD MMM YYYY") +"End : "+enddate.format("DD MMM YYYY"));

      if (i == 0) {
        const week: Semester = {
          id: i + 1,
          name: 'Week #' + (i + 1),
          startDate: this.data.startDate,
          endDate: edate
        };

        list.push(week);
      } else if (i + 1 == nweek) {
        const week: Semester = {
          id: i + 1,
          name: 'Week #' + (i + 1),
          startDate: sdate,
          endDate: this.data.endDate
        };
        list.push(week);
      } else {
        const week: Semester = {
          id: i + 1,
          name: 'Week #' + (i + 1),
          startDate: sdate,
          endDate: edate
        };
        list.push(week);
      }

      startdate = moment(startdate.add(7, 'days'));
      enddate = moment(startdate);
    }
    if (WeeklyService instanceof PaperWeeklyService) {
      WeeklyService = <PaperWeeklyService>WeeklyService;
      let checklist = WeeklyService.getBySectionSubjectId(sectionSubjectId);

      checklist.forEach(v => {
        //  if( == )
        let i = list.findIndex(f => f.id == v.weekId);
        if (i > -1) {
          list.splice(i, 1);
        }
      });
    } else {
      WeeklyService = <ElectronicWeeklyService>WeeklyService;
      let checklist = WeeklyService.getBySectionSubjectId(sectionSubjectId);

      checklist.forEach(v => {
        //  if( == )
        let i = list.findIndex(f => f.id == v.weekId);
        if (i > -1) {
          list.splice(i, 1);
        }
      });
    }

    return list;
  }

  getPlanType(){

    return [
      {id:1,name:"Weekly"},
      {id:2,name:"Yearly"},
      {id:3,name:"Semester"}
    ]
  }

  
  getPlanCategory(){
    return [
      {id:1,name:"Action Plan"},
      {id:2,name:"Operation Plan"},
      {id:3,name:"Development Plan"}
    ]
  }


  getPlanGroup(){
    return [
      {id:1,name:"Normal"},
      {id:2,name:"Remedialy"}
    ]
  } 


}

@Injectable({
  providedIn: 'root'
})
export class PaperWeeklyService {
  data: Paper[] = [];
  constructor() {}
  public ChangeNotefier = new EventEmitter();

  getall(): Paper[] {
    return this.data;
  }

  getById(id: number): Paper {
    return this.data.find(f => f.id == id);
  }

  getBySectionSubjectId(id: number): Paper[] {
    const list = [];
    this.data.forEach(item => {
      if (item.subjectsectionId == id) {
        list.push(item);
      }
    });

    return list;
  }

  count(): number {
    if (this.data) return this.data.length;
    else return 0;
  }

  insertPaper(item: Paper) {
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removePaper(item: Paper) {
    let i = this.data.findIndex(f => f.id == item.id);
    if (i > -1) {
      this.data.splice(i, 1);
      this.ChangeNotefier.emit(this.data);
    }
  }

  updatePaper(id: number, item: Paper) {
    let i = this.data.findIndex(f => f.id == id);
    if (i > -1) {
      this.data[i] = { ...item };
      this.ChangeNotefier.emit(this.data);
    }
  }
}


@Injectable({
  providedIn: 'root'
})
export class PaperService {
  data: Paper[] = [];
  constructor() {
   
  }
  public ChangeNotefier  = new EventEmitter();

  getall(): Paper[] {

    return this.data;
  }

  getById(id :number): Paper {

    return this.data.find(f=>f.id ==id);
  }

  getBySectionSubjectId(id :number): Paper[]{

    const list   = [];
    this.data.forEach(item=>{
        if(item.subjectsectionId ==id)
        {
          list.push(item);
        }

    });

    return list;
  }

  count() :number{
    if(this.data)
    return this.data.length;
    else
    return 0;
  }

  insertPaper (item :Paper){
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removePaper(item : Paper)
  {
    let i =  this.data.findIndex(f=>f.id ==item.id);
    if(i>-1)
    {
      this.data.splice(i,1);
      this.ChangeNotefier.emit(this.data);
    }
  }
  
  updatePaper(id :number ,item:Paper){
    let i= this.data.findIndex(f=>f.id ==id);
    if(i>-1)
    {
    this.data[i]={...item}
    this.ChangeNotefier.emit(this.data);
    }
  }



}

@Injectable({
  providedIn: 'root'
})
export class PaperYearlyService {
  data: Paper[] = [];
  constructor() {}
  public ChangeNotefier = new EventEmitter();

  getall(): Paper[] {
    return this.data;
  }

  getById(id: number): Paper {
    return this.data.find(f => f.id == id);
  }
  getBySectionSubjectId(id: number) {
    const list = [];
    this.data.forEach(item => {
      if (item.subjectsectionId == id) {
        list.push(item);
      }
    });

    return list;
  }

  count(): number {
    if (this.data) return this.data.length;
    else return 0;
  }

  insertPaper(item: Paper) {
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removePaper(item: Paper) {
    let i = this.data.findIndex(f => f.id == item.id);
    if (i > -1) {
      this.data.splice(i, 1);
      this.ChangeNotefier.emit(this.data);
    }
  }

  updatePaper(id: number, item: Paper) {
    let i = this.data.findIndex(f => f.id == id);
    if (i > -1) {
      this.data[i] = { ...item };
      this.ChangeNotefier.emit(this.data);
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class ElectronicWeeklyService {
  data: Electronic[] = [];
  constructor() {}
  public ChangeNotefier = new EventEmitter();

  getall(): Electronic[] {
    return this.data;
  }

  getById(id: number): Electronic {
    return this.data.find(f => f.id == id);
  }

  getBySectionSubjectId(id: number): Electronic[] {
    const list = [];
    this.data.forEach(item => {
      if (item.subjectsectionId == id) {
        list.push(item);
      }
    });

    return list;
  }

  count(): number {
    if (this.data) return this.data.length;
    else return 0;
  }

  insertElectronic(item: Electronic) {
    this.data.push(item);
    this.ChangeNotefier.emit(this.data);
  }

  removeElectronic(item: Electronic) {
    let i = this.data.findIndex(f => f.id == item.id);
    if (i > -1) {
      this.data.splice(i, 1);
      this.ChangeNotefier.emit(this.data);
    }
  }

  updateElectronic(id: number, item: Electronic) {
    let i = this.data.findIndex(f => f.id == id);
 
    if (i > -1) {
      this.data[i] = { ...item };
      this.ChangeNotefier.emit(this.data);
    }
  }
}
